import type { ShuttleEpcModel } from '@/types/models/ShuttleEpcModel'

export type ShuttleEpcState = {
    shuttleEpcs: ShuttleEpcModel[]
}

export enum EShuttleEpcActions {
    FETCH_SHUTTLE_EPCS = 'fetchShuttleEpcs',
    CREATE_SHUTTLE_EPC = 'createShuttleEpc',
    CREATE_SHUTTLE_EPC_RANGE = 'createShuttleEpcRange',
    DELETE_SHUTTLE_EPC = 'deleteShuttleEpc'
}

export enum EShuttleEpcMutations {
    SET_SHUTTLE_EPCS = 'setShuttleEpcs',
    SET_TOTAL = 'setTotal',
    SET_LOADING = 'setLoading'
}
